import { GENERATE_API, REPORT_HISTORY_API } from "./constants";

const buildHeaders = (accessToken) => ({
  Authorization: `Bearer ${accessToken}`,
  "Content-Type": "application/json",
});

export const requestGenerateReport = async ({ campaignId, accessToken }) => {
  const res = await fetch(
    `${GENERATE_API}?campaign_id=${encodeURIComponent(campaignId.trim())}`,
    {
      method: "GET",
      headers: buildHeaders(accessToken),
    }
  );
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Error generating report");
  }

  return data;
};

export const requestReportHistory = async ({ accessToken }) => {
  const res = await fetch(REPORT_HISTORY_API, {
    method: "GET",
    headers: buildHeaders(accessToken),
  });
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Error fetching report history");
  }

  if (Array.isArray(data)) {
    return data;
  }

  if (Array.isArray(data?.records)) {
    return data.records;
  }

  if (Array.isArray(data?.items)) {
    return data.items;
  }

  return [];
};

export const requestHistoryDownload = async ({ item, accessToken }) => {
  const res = await fetch(REPORT_HISTORY_API, {
    method: "POST",
    headers: buildHeaders(accessToken),
    body: JSON.stringify(item),
  });
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Error downloading report");
  }

  return data;
};
